// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DnaSyngoviaScoreSeverityEtype } from '../enum/dna-syngovia-score-severity-type';

@Injectable({
  providedIn: 'root',
})
export class DnaSyngoviaScoreSeverityService {
  private readonly severityLabels: { [key: string]: string } = {
    low: this.translateService.instant('syngovia.label.low'),
    medium: this.translateService.instant('syngovia.label.medium'),
    high: this.translateService.instant('syngovia.label.high'),
  };

  public constructor(private readonly translateService: TranslateService) {}

  public scoreSeverity(score: number): string {
    let severity = DnaSyngoviaScoreSeverityEtype.LOW;
    if (0 <= score && score < 50) {
      severity = DnaSyngoviaScoreSeverityEtype.LOW;
    } else if (50 <= score && score < 100) {
      severity = DnaSyngoviaScoreSeverityEtype.MEDIUM;
    } else if (score >= 100) {
      severity = DnaSyngoviaScoreSeverityEtype.HIGH;
    }

    return severity;
  }

  public label(value: string): string {
    return this.severityLabels[value] ?? value;
  }
}
